import Icon from '../../shared/components/Icons';
import { fmtDay } from '../../shared/data/common';
import { clock, durationLabel } from './searchModel';
import { VehicleImage } from './TransferList';

/**
 * Transfer summary used on review, confirmation and booking details pages. Also reads demo bookings
 * saved before live transfers (name, example, extras).
 */
export default function TransferSummary({ summary: s }) {
  const label = s.label || s.name;
  return (
    <div className="sum">
      <div className="sum-media">
        <VehicleImage vehicle={{ label, imageUrl: s.imageUrl }} size="sm" />
        <div>
          <span className="tag">{s.journey || `${s.shared ? 'Shared' : 'Private'} transfer`}{s.roundTrip ? ' · Round trip' : ''}</span>
          <h3>{label}</h3>
          {(s.similarModels || s.example) && <span className="muted small">{s.similarModels || s.example}</span>}
        </div>
      </div>
      <div className="route-box">
        <div><span className="dot dot-start" /><div><span className="muted small">Pickup</span><b>{s.pickup}</b></div></div>
        <div><span className="dot dot-end" /><div><span className="muted small">Drop</span><b>{s.drop}</b></div></div>
      </div>
      <div className="kv-grid">
        <div><span className="muted small">Pickup</span><b>{fmtDay(s.date)}, {clock(s.time)}</b></div>
        {s.returnDate && <div><span className="muted small">Return pickup</span><b>{fmtDay(s.returnDate)}, {clock(s.returnTime)}</b></div>}
        <div><span className="muted small">Passengers</span><b>{s.passengers}</b></div>
        {s.distance && <div><span className="muted small">Distance</span><b>{s.distance}{s.duration ? ` · ${durationLabel(s.duration)}` : ''}</b></div>}
        {s.flightNo && <div><span className="muted small">Flight no.</span><b>{s.flightNo}</b></div>}
      </div>
      <div className="sum-foot">
        {(s.seats != null || s.bags != null) && (
          <span>{s.seats != null && <><Icon name="user" size={14} /> {s.seats} seats</>}{s.seats != null && s.bags != null && ' · '}{s.bags != null && <><Icon name="bag" size={14} /> {s.bags} bags</>}</span>
        )}
        {s.extras?.length > 0 && <span><Icon name="check" size={14} /> Extras: {s.extras.map((e) => e.label).join(', ')}</span>}
        {s.waitingTime && <span className="text-primary"><Icon name="clock" size={14} /> {s.waitingTime}</span>}
        {s.meetAndGreet && <span><Icon name="user" size={14} /> Meet & greet</span>}
        {s.freeCancellation && <span className="text-primary"><Icon name="check" size={14} /> {s.freeCancellation}</span>}
        {s.request && <span><Icon name="file" size={14} /> Note: {s.request}</span>}
      </div>
    </div>
  );
}
